import { render } from "./Cropper.vue?vue&type=template&id=270409d6&scoped=true&ts=true"
import script from "./Cropper.vue?vue&type=script&lang=ts"
export * from "./Cropper.vue?vue&type=script&lang=ts"

import "./Cropper.vue?vue&type=style&index=0&id=270409d6&scoped=true&lang=scss"
import "./Cropper.vue?vue&type=style&index=1&id=270409d6&lang=css"

import exportComponent from "/builds/psj7085139/sam/samva-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270409d6"]])

export default __exports__